import React, { forwardRef, ForwardRefRenderFunction } from "react";
//#region types
import { BaseFormViewComponentProps, FormHandles } from "models/propTypes/genericFormProps";
import { FormEnums } from "models/enums";
import { AnnualAccountFormTypes } from "models/formTypes";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import { GenericForm } from "components/common";
//#endregion

const AnnualAccountCommentForm: ForwardRefRenderFunction<FormHandles, BaseFormViewComponentProps> = (props, ref) => {
  return (
    <GenericForm<AnnualAccountFormTypes.Comment>
      formRef={ref}
      {...props}
      enableControlLables
      formGridLayout={{ message: false }}
      fields={{
        message: {
          controlLabel: TranslationKeys.AnnualAccount.CommentDialogHeading,
          label: TranslationKeys.Common.Comment,
          placeholder: TranslationKeys.AnnualAccount.CommentPlaceholder,
          descriptionText: TranslationKeys.AnnualAccount.CommentDialogInfoText,
          type: FormEnums.FormFieldType.TEXTAREA,
        },
      }}
    />
  );
};

export default forwardRef(AnnualAccountCommentForm);